module.exports = __webpack_public_path__ + "static/fonts/heiCN-Regular.56195441.otf";